<template>
  <div>
    <div>
      <div class="row">
        <div class="col-12 col-md-6 my-2">
          <label for="farsi_name">
            {{ $t("label.farsi_name") }}
          </label>
          <input
              id="farsi_name"
              name="farsi_name"
              class="form-control"
              v-model="form_data.farsi_name"
          />
          <small v-if="next_step_clicked && !validation_errors.farsi_name" class="text-danger px-2">تکمیل این فیلد
            الزامی است.</small>
        </div>
        <div class="col-12 col-md-6 my-2">
          <label for="english_name">
            {{ $t("label.english_name") }}
          </label>
          <input
              id="english_name"
              name="english_name"
              class="form-control"
              v-model="form_data.english_name"
              dir="ltr"
          />
          <small v-if="next_step_clicked && !validation_errors.english_name" class="text-danger px-2">تکمیل این فیلد
            الزامی است.</small>
        </div>

        <div class="col-12 col-md-6 my-2">
          <label for="subcategory_code">
            {{ $t("label.subcategory_code") }}
          </label>
          <select
              id="subcategory_code"
              name="subcategory_code"
              v-model="form_data.subcategory_code"
              class="form-control kt-selectpicker"
          >
            <option
                v-bind:key="subcategory.key"
                v-for="subcategory in subcategories"
                :value="subcategory.key"
            >
              {{ subcategory.value + ' - ' + subcategory.key}}
            </option>
          </select>
          <small v-if="next_step_clicked && !validation_errors.subcategory_code" class="text-danger px-2">تکمیل این فیلد
            الزامی است.</small>
        </div>
            <!-- <div class="col-12 col-md-6 my-2">
                <label
                    for="business_certificate_number"
                    class="d-flex align-items-center"
                >
                    {{ $t('label.business_certificate_number') }}
                    <small class="text-muted mr-2">(اختیاری)</small>
                </label>
                <input
                    id="business_certificate_number"
                    name="business_certificate_number"
                    class="form-control"
                    v-model="form_data.business_certificate_number"
                    dir="ltr"
                />
            </div> -->
            <div class="col-12 col-md-6 my-2">

            <label for="farsi_name">
              {{ $t("label.tax_payer_code") }}
              <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                <span v-if="form_data.has_enamad" class="tooltip-text">کدمالیاتی باید به نام پذیرنده باشد و در سامانه مالیات گام ۴ باشد.</span>
                              <i class="fa fa-info-circle"></i>
              </span>
            </label>
            <input
                    id="tax_payer_code"
                    :disabled="form_data.type !== shopType.BUSINESS"
                    name="tax_payer_code"
                    class="form-control"
                    v-model="form_data.tax_payer_code"
            />
            <small v-if="next_step_clicked && !validation_errors.tax_payer_code" class="text-danger px-2">کدمالیاتی باید
            ده کاراکتر باشد.</small>
            <div class="my-2" v-if="form_data.has_enamad">
              <a href="https://www.aparat.com/v/m2kSY" target="_blank" class="py-2 badge badge-danger">  آموزش دریافت کد رهگیری مالیاتی </a>
          </div>

        </div>

         <div v-if="form_data.wizard_gateway_type == '1'" class="col-12 col-md-6 my-2">
          <label for="site_address">
            {{ $t("label.site_address") }}
          </label>
          <input
              dir="ltr"
              id="site_address"
              name="site_address"
              class="form-control"
              disabled
              v-model="form_data.site_address"
          />
          <small v-if="next_step_clicked && !validation_errors.site_address" class="text-danger px-2">تکمیل این فیلد
            الزامی است.</small>
        </div>
        <div v-else class="col-12 col-md-6 my-2">
          <label for="site_address">
            {{ $t("label.site_address") }}
            <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                <span class="tooltip-text">دامنه سایت باید اینماد داشته باشد و اینماد به نام پذیرنده باشد.</span>
                <i class="fa fa-info-circle"></i>
            </span>
          </label>
          <input
            
            dir="ltr"
            id="site_address"
            name="site_address"
            class="form-control"
            v-model="form_data.site_address"
          />
          <small v-if="next_step_clicked && !validation_errors.site_address" class="text-danger px-2">تکمیل این فیلد
            الزامی است.</small>
        </div>
    </div>
      <div class="row">
          <div  class="col-12 col-md-6 my-2">
              <div >
                  <div class="form-group form-check d-flex">
                      <label class="switch">
                          <input  type="checkbox" class="custom-control-input" id="has_limit2" name="has_limit"
                                 v-model="abroad_ips_only_by_user">
                          <span class="slider round"></span>
                      </label>
                      <p dir="rtl" class="mx-3">{{ $t('label.abroad_ip_limitation_by_user') }}</p>
                  </div>
                  <transition name="fade">
                      <kt-form-group v-if="abroad_ips_only_by_user">
                          <kt-form-label>
                              {{ $t('label.limit_amount') }}
                          </kt-form-label>
                          <div class="kt-input-icon kt-input-icon--right">
                    <span class="kt-input-icon__icon kt-input-icon__icon--right">
                        <span>{{ $t('label.rial') }}</span>
                    </span>
                              <kt-form-control
                                      type="text"
                                      dir="ltr"
                                      id="limit_amount"
                                      name="limit_amount"
                                      v-model="form_data.limit_amount_by_user"
                              >
                              </kt-form-control>
                          </div>
                      </kt-form-group>
                  </transition>
              </div>

          </div>
         <!-- <div class="col-12 col-md-6 my-2">
          <div class="form-group form-check d-flex">
                      <label class="switch">
                          <input  type="checkbox" class="custom-control-input" id="has_enamad" name="has_enamad"
                                  :disabled="form_data.type !== shopType.BUSINESS"
                                 v-model="has_enamad">
                          <span class="slider round"></span>
                      </label>
                      <p v-if="form_data.has_enamad" dir="rtl" class="mx-3">{{ $t('label.enamad_title') }}</p>
                      <p v-else dir="rtl" class="mx-3">{{ $t('label.not_have_enamad_title') }}</p>
                  </div>
        </div> -->

      </div>
      <div class="row">
        <div class="col-12 col-md-6 my-2">
              <label>
                  {{ $t("label.logo") }}
              </label>
              <label
                      for="logo_file"
                      class="d-block btn btn-secondary btn-wide label-file"
              >
                  <kt-icon type="fa" name="paperclip"></kt-icon>
                  {{ $t("gateway.btn.click_me") }}
              </label>
              <input
                      @change="processLogoFile"
                      type="file"
                      class="custom-file-upload d-none"
                      name="logo"
                      id="logo_file"
                      accept="image/*"
              />
              <small v-if="next_step_clicked && !validation_errors.logo" class="text-danger px-2">تکمیل این فیلد الزامی
                  است.</small>
              <ul class="text-muted px-4 mt-1 mb-0" style="font-size: 0.9em;">
                <li>فرمت مجاز: PNG، JPEG، JPG</li>
                <li>حداکثر حجم: 2 مگابایت</li>
              </ul>
          </div>
        <div class="col-12 col-md-6 my-2" v-if="!has_enamad && form_data.type === shopType.BUSINESS">
          <label for="namad_services_code">
            {{ $t("label.name_groups") }}
          </label>
          <select
              id="namad_services_code"
              name="namad_services_code"
              v-model="form_data.namad_services_code"
              class="form-control kt-selectpicker"
          >
            <option
                v-for="item in enamadProduct"
                v-bind:key="item.value"
                :value="item.value"
            >
              {{ item.name }}
            </option>
          </select>
          <small v-if="next_step_clicked || !validation_errors.has_enamad" class="text-danger px-2">تکمیل این فیلد
            الزامی است.</small>
        </div>

        <div class="col-12 col-md-6 my-2">
            <kt-col lg="6" md="6" xs="12" class="d-flex justify-content-end">
                <img :src="picPreview" class="preview_picture"  v-if="picPreview !== ''"/>
                <i class="fa fa-window-close text-danger remove_picture" v-if="picPreview !== ''" @click="removePicture"></i>
            </kt-col>
          </div>
      </div>
    <div class="d-flex align-items-center px-3 mt-4">
      <div class="mr-auto">
        <button
            type="button"
            @click="next_step()"
            class="btn btn-success px-4"
            style="border-radius: 10px"
        >
          <span>مرحله بعد</span>
        </button>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import {subcategories} from "@/constants/subcategories";
import Inputmask from "inputmask";
import {mapGetters} from "vuex";
import p2f from 'persian-to-pinglish';
import {getFinglish} from '@/constants/names';
import {enamadProduct} from "@/constants/EnamadProduct";
import {shopType} from "@/constants/ShopType";

export default {
  props: {
    wizard: Object,
    form_data: Object,
  },
  computed: {
      shopType() {
          return shopType
      },
    ...mapGetters("shebaNumber", ["sheba_numbers"]),
    gateway_farsi_name() {
      return this.form_data.farsi_name;
    }
  },
  watch: {
    gateway_farsi_name() {
      let finglish = getFinglish(this.form_data.farsi_name);

      if (finglish) {
        this.form_data.english_name = finglish;
      } else {
        this.form_data.english_name = p2f(this.form_data.farsi_name);
      }
    },
    validation_errors() {
      this.next_step_clicked = false;
    },
    has_enamad(value){
      if(!value){
        this.form_data.has_enamad = 0
      }else{
        this.form_data.has_enamad = 1
        this.form_data.namad_services_code = []
      }
      this.renderKTPicker()
    }
    // abroad_ips_only_by_user(val){
    //   console.log(val);
    // }
  },
  data() {
    return {
        abroad_ips_only_by_user:false,
        has_enamad: 1,
        ip_limitations:[
            {
                name:"ندارد",
                value:0,
            },
            {
                name:"دارد",
                value:1,
            }
        ],
        abroad_ips_only:false,
        next_step_clicked: false,
        validation_errors: {},
        subcategories: subcategories,
        enamadProduct: enamadProduct,
        picPreview: ''
      };
  },
  mounted() {
    if (this.$store.getters["pardakhtShakhsi/status"] != 'success') {
      this.$store.dispatch("pardakhtShakhsi/fetch");
    }
    this.form_data.has_enamad = this.has_enamad
  },
  methods: {
    renderKTPicker() {
      setTimeout(() => {
        $('.kt-selectpicker').selectpicker({
          size: 4,
          liveSearch: true,
          noneResultsText: i18n.t('selectpicker.none_result'),
          selectAllText: i18n.t('selectpicker.select_all'),
          noneSelectedText: i18n.t('selectpicker.nothing_selected')
        })
      }, 500)

    },
    next_step() {
      this.next_step_clicked = true;
      this.form_data.abroad_ips_only_by_user=this.abroad_ips_only_by_user === true ? 1 : 0;

      if (this.step_is_valid()) {
        this.validation_errors = {};
        this.wizard.current_step = 3;
      }
    },
    step_is_valid() {
      this.validation_errors.farsi_name = !!this.form_data.farsi_name;
      this.validation_errors.english_name = !!this.form_data.english_name;
      this.validation_errors.subcategory_code = !!this.form_data.subcategory_code;
      this.validation_errors.site_address = (!!this.form_data.site_address && this.form_data.site_address != 'https://');
      this.validation_errors.merchant_share_percent = !!this.form_data.merchant_share_percent;
      this.validation_errors.logo = !!this.form_data.logo;
      // if ( this.form_data.tax_payer_code !=null ) {
      if (this.form_data.type === shopType.BUSINESS) {
          if (  this.form_data.has_enamad === 1  ) {
              if ( this.form_data.tax_payer_code.length < 10 || this.form_data.tax_payer_code.length >10){
                  this.validation_errors.tax_payer_code = false;
              }
              else
                  this.validation_errors.tax_payer_code = true;
              this.validation_errors.has_enamad = true;
          } else {
              if (this.form_data.tax_payer_code.length < 10 || this.form_data.tax_payer_code.length > 10) {
                  this.validation_errors.tax_payer_code = false;
              } else
                  this.validation_errors.tax_payer_code = true;
              if (this.form_data.namad_services_code.length === 0)
                  this.validation_errors.has_enamad = false;
              else
                  this.validation_errors.has_enamad = true;
          }
      }
      else {
          this.validation_errors.tax_payer_code = true;
          this.validation_errors.has_enamad = true;

      }




            return this.validation_errors.farsi_name
          && this.validation_errors.english_name
          && this.validation_errors.subcategory_code
          && this.validation_errors.site_address
          && this.validation_errors.logo
          && this.validation_errors.tax_payer_code
          && this.validation_errors.has_enamad
          ;
    },
    processLogoFile(e) {
      this.form_data.logo = event.target.files[0];
      this.picPreview = URL.createObjectURL(e.target.files[0]);
      if (this.validateSize(event.target)) {
        this.validateFormat(event.target);
      }
    },
    removePicture(){
      this.picPreview = ''
    },
    validateSize(file) {
      var FileSize = file.files[0].size / 1024 / 1024; // in MB
      if (FileSize > 2) {
        alert(i18n.t("authenticate.hint.fourth"));
        $(file).val("");
        this.form_data.logo = null;
        return false;
      }

      return true;
    },
    validateFormat(file) {
      let jq_file = $(file);
      let file_name = jq_file.val();
      let extension = file_name.replace(/^.*\./, "");
      if (extension === file_name) {
        extension = "";
      } else {
        extension = extension.toLowerCase();
      }

      switch (extension) {
        case "png":
        case "jpeg":
        case "jpg":
          break;
        default:
          alert(i18n.t("authenticate.input_format_err"));
          $(file).val("");
          this.form_data.logo = null;
          return false;
      }

      return true;
    },
  },
};
</script>

<style scoped>

.preview_picture{
  width: 100%;
  height: 150px;
}

.remove_picture{
  cursor: pointer;
  position: absolute;
  top: -5px;
  right: 10px;
}
</style>